/* Ширина картинки NewsItemCard на десктопе, ниже 768px — на всю ширину. */
export const NEWS_ITEM_CARD_IMAGE_WIDTH = 320;

/*
  Размеры картинок блоков хроники — из вёрстки. Пропорции берутся из
  CROP_RATIO_CHRONICLE, здесь только целевая ширина.
*/

/* image_right_single: 80x80. */
export const NEWS_ITEM_SMALL_IMAGE_WIDTH = 80;

/* image_left_big: до 320px на десктопе, на всю ширину до 767px. */
export const NEWS_ITEM_WIDE_IMAGE_WIDTH = 320;
export const NEWS_ITEM_WIDE_IMAGE_WIDTHS = [
  320, 480, 640, 768, 960, 1280, 1536, 2304,
] as const;

/* background_giant: тянется по ячейке грида, берём десктопный размер. */
export const NEWS_ITEM_BIG_IMAGE_WIDTH = 728;

/* gallery_wide: 1080x148 на всю строку. */
export const NEWS_ITEM_GALLERY_WIDE_WIDTH = 1080;

/* object_images: 230x320. */
export const NEWS_ITEM_OBJECT_IMAGE_WIDTH = 230;

/* Фото в сетке галереи gallery_wide: 270x140, своего кропа в конфиге нет. */
export const NEWS_ITEM_GALLERY_PHOTO_WIDTH = 270;
export const NEWS_ITEM_GALLERY_PHOTO_HEIGHT = 140;
